import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["type"]
const _hoisted_2 = {
  key: 0,
  class: "button__loading-spinner"
}

import { ButtonTypes } from '@/types/enums/button'
import { UiPopconfirm, UiTooltip } from '@/components/common/ui'

export interface IPropsTheButton {
    small?: boolean
    outline?: boolean
    primary?: boolean
    loading?: boolean
    type?: ButtonTypes
    disabled?: boolean
    showTooltip?: boolean
    tooltipMessage?: string
    confirmationRequired?: boolean
    confirmationCallback?: () => void
    confirmationMessage?: ''
    fullWidth?: boolean
    noButtonStyle?: boolean
}

interface IEventUiButton {
    (e: 'click'): void
}


export default /*#__PURE__*/_defineComponent({
  props: {
    small: { type: Boolean, required: false },
    outline: { type: Boolean, required: false },
    primary: { type: Boolean, required: false, default: false },
    loading: { type: Boolean, required: false, default: false },
    type: { type: null, required: false, default: ButtonTypes.SUBMIT },
    disabled: { type: Boolean, required: false, default: false },
    showTooltip: { type: Boolean, required: false, default: false },
    tooltipMessage: { type: String, required: false, default: '' },
    confirmationRequired: { type: Boolean, required: false, default: false },
    confirmationCallback: { type: Function, required: false, default: () => {} },
    confirmationMessage: { type: String, required: false, default: '' },
    fullWidth: { type: Boolean, required: false, default: true },
    noButtonStyle: { type: Boolean, required: false, default: false }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'click'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { small?: boolean, outline?: boolean, primary: boolean, loading: boolean, type: ButtonTypes, disabled: boolean, showTooltip: boolean, tooltipMessage: string, confirmationRequired: boolean, confirmationCallback: () => void, confirmationMessage: '', fullWidth: boolean, noButtonStyle: boolean }




const onButtonClick = (e: Event) => {
    if (!props.confirmationRequired || props.disabled) {
        e.stopPropagation()
    }
    if (props.confirmationRequired) {
        return
    }
    if (!props.loading && !props.disabled) handleConfirm()
}
const handleConfirm = () => {
    props.confirmationCallback && props.confirmationCallback()
    emit('click')
}

return (_ctx: any,_cache: any) => {
  const _component_IconCog = _resolveComponent("IconCog")!

  return (_openBlock(), _createBlock(_unref(UiTooltip), {
    position: "top",
    message: props.tooltipMessage,
    disabled: !props.showTooltip
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(UiPopconfirm), {
        "full-width": props.fullWidth,
        text: __props.confirmationMessage,
        onConfirm: handleConfirm
      }, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            type: props.type,
            class: _normalizeClass(["button", [
                    _ctx.$attrs.class,
                    {
                        'button--default': !props.outline && !props.primary,
                        'button--primary': props.primary,
                        'button--outline': props.outline,
                        'button--disabled': props.disabled,
                        'button--clear': props.noButtonStyle,
                    },
                ]]),
            onClick: onButtonClick
          }, [
            _renderSlot(_ctx.$slots, "default"),
            (props.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_IconCog, { class: "animate-spin" })
                ]))
              : _createCommentVNode("", true)
          ], 10, _hoisted_1)
        ]),
        _: 3
      }, 8, ["full-width", "text"])
    ]),
    _: 3
  }, 8, ["message", "disabled"]))
}
}

})